if (!customElements.get('withdrawal-button')) {
  class WithdrawalButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const button = this.querySelector('button');
      this.handleClick = this.handleClick.bind(this);
      button.addEventListener('click', this.handleClick);
    }

    handleClick() {
      const floatingWithdrawalButton = document.querySelector('.widerruf-floating-btn');
      if (floatingWithdrawalButton) {
        floatingWithdrawalButton.click();
      }
    }
  }

  customElements.define('withdrawal-button', WithdrawalButton);
}